export function x(p) {
  return p[0];
}

export function y(p) {
  return p[1];
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/point.js
// module id = 1291
// module chunks = 0